export const NA_US = "United States";
export const NA_CA = "Canada";
export const NA_MX = "Mexico";
export const EU = "Europe";
export const ANZ = "Asia Pacific";